<template>
    <div>
        <div :class="['form-group', { 'mb-4': !removeMargin }]">
            <label v-if="label.length > 0" :for="name">
                <strong>
                    {{ label }}
                    <span v-if="required" class="text-danger">*</span>
                </strong>
            </label>

            <div :class="['input-group', { 'mb-3': !removeMargin }]">
                <span v-if="prepend" class="input-group-text">
                  {{ prepend }}
                </span>
                <input
                    :id="name"
                    :name="name"
                    :placeholder="placeholder"
                    v-model="model"
                    :class="['form-control', { 'is-invalid': hasError }]"
                    :disabled="disabled"
                    :readonly="readonly"
                    :required="required"
                    :type="type"
                    v-bind="$attrs"
                />
                <span v-if="append" class="input-group-text">
                  {{ append }}
                </span>
            </div>

            <div v-if="subtext" v-html="subtext"></div>

            <div v-if="hasError" class="alert alert-danger mt-2" role="alert">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script setup>

const model = defineModel({
    type: String,
    default: ''
});

defineProps({
    type: {
        type: String,
        default: 'text'
    },
    label: {
        type: String,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    placeholder: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
        default: false
    },
    disabled: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    },
    removeMargin: {
        type: Boolean,
        default: false
    },
    subtext: {
        type: String,
        default: null
    },
    prepend: {
        type: String,
        default: null
    },
    append: {
        type: String,
        default: null
    },
    hasError: {
        type: Boolean,
        default: false
    },
    errorMessage: {
        type: String,
        default: null
    },
});
</script>
